module.exports = __webpack_public_path__ + "static/media/word.cdfafa7c.svg";